<div class="pssr-page">
  <div class="pssr-page-header">
    <h1 class="pssr-page-title">{{ 'errors.unauthorized.title' | translate }}</h1>
  </div>

  <div class="pssr-page-content">
    <div class="pssr-empty-state">
      <p>{{ 'errors.unauthorized.message' | translate }}</p>
      <a
        class="pssr-link"
        href="/">
        {{ 'errors.actions.returnHome' | translate }}
      </a>
    </div>
  </div>
</div>
